var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f1f1f2;\n      }\n\n      .cls-2 {\n        fill: #001213;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 78,
    cy: 78,
    r: 77
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.32,95.75c0-.59.03-1.18.1-1.79.07-.61.18-1.35.34-2.23.16-.88.35-1.97.58-3.28l2.77-15.84c.14-.72.03-1.29-.31-1.69-.34-.41-.88-.72-1.62-.95-.74-.23-1.68-.41-2.81-.54l-1.02-.14.61-3.11h12.25l-4.13,23.49c-.14.95-.26,1.77-.37,2.47-.11.7-.19,1.29-.24,1.76-.05.47-.07.89-.07,1.25,0,.59.18,1.04.54,1.35.36.32.9.47,1.63.47.68,0,1.35-.1,2.03-.31.68-.2,1.3-.42,1.86-.64.56-.23.96-.38,1.18-.47l-.68,3.52c-.45.32-.99.63-1.63.95-.63.32-1.34.56-2.13.74-.79.18-1.64.27-2.54.27-1.22,0-2.31-.19-3.28-.58-.97-.38-1.73-.97-2.27-1.76-.54-.79-.81-1.77-.81-2.94ZM76.78,54.12c0-1.26.39-2.26,1.18-2.98.79-.72,1.77-1.08,2.95-1.08s2.15.36,2.94,1.08c.79.72,1.18,1.72,1.18,2.98s-.4,2.27-1.18,3.01c-.79.74-1.77,1.12-2.94,1.12s-2.16-.37-2.95-1.12c-.79-.74-1.18-1.75-1.18-3.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonInfo);
export default __webpack_public_path__ + "static/media/button_info.503d72c1b1560cec2d8b6be38a9c113b.svg";
export { ForwardRef as ReactComponent };